/**
 * Reports Vuex module for Portal Application
 * 
 * @module Reports
 * @see
 * @author Maureen Ronquillo (Fresche Solutions)
 * @date April 2025
 */

import portalapi from "@services/portalapi";
import { resetStateData } from "@/utils/vuexStoreUtils";
import { getField, updateField } from "vuex-map-fields";

const DEFAULT_STATE = {
    monthlyPurchasesSummary: {
        details: [],
        total:{}
    },
	monthlyPurchases: {
        details: [],
        total:{}
    },
    monthlyAccountGroup: {
        details: [],
        total:{}
    },
    monthlyItemGroup: {
        details: [],
        total:{}
    },
};

const state = structuredClone(DEFAULT_STATE);

const getters = {
    getField,

    getMonthlyPurchasesSummary(st) {
        return st.monthlyPurchasesSummary;
    },

	getMonthlyPurchases(st) {
        return st.monthlyPurchases;
    },

    getMonthlyItemGroup(st) {
        return st.monthlyItemGroup;
    },

    getMonthlyAccountGroup(st) {
        return st.monthlyAccountGroup;
    },
};

const mutations = {
    updateField, // for vuex-map-fields

    async clearStateData(st) {
        st = resetStateData(st, DEFAULT_STATE);
    },

    setMonthlyPurchasesSummary(st, payload) {
        st.monthlyPurchasesSummary  = payload;
    },

	setMonthlyPurchases(st, payload) {
        st.monthlyPurchases  = payload;
    },

    setMonthlyAccountGroup(st, payload) {
        st.monthlyAccountGroup  = payload;
    },

    setMonthlyItemGroup(st, payload) {
        st.monthlyItemGroup  = payload;
    },
};

const actions = {
    // Get monthly purchases summary
    async fetchMonthlyPurchasesSummary({ commit })
    {
        const response = await portalapi.moduleReports.getMonthlyPurchasesSummary();
        commit("setMonthlyPurchasesSummary", response);

        // TODO: Implement checking once the API is available (Post go live)
        // if (response && response.status == vm.config.globalProperties.$constants.HTTP_STATUS_CODES.OK) {
        //     await commit("setMonthlyPurchasesSummary", response.data);
        // }
    },

    // Get monthly purchases details
    async fetchMonthlyPurchases({ commit }, payload)
    {
        const response = await portalapi.moduleReports.getMontlyPurchases(payload.month, payload.year);
        commit("setMonthlyPurchases", response[0]);

        // TODO: Implement checking once the API is available (Post go live)
        // if (response && response.status == vm.config.globalProperties.$constants.HTTP_STATUS_CODES.OK) {
        //     await commit("setMonthlyPurchases", response.data);
        // }
    },

    // Get monthly purchases summary by account group
    async fetchMonthlyPurchasesAccountGroup({ commit }, payload)
    {
        const response = await portalapi.moduleReports.getMontlyPurchasesByAccountGroup(payload.month, payload.year, payload.accountGroup);
        commit("setMonthlyAccountGroup", response[0]);
        // TODO: Implement checking once the API is available (Post go live)
        // if (response && response.status == vm.config.globalProperties.$constants.HTTP_STATUS_CODES.OK) {
        //     await commit("setMonthlyPurchases", response.data);
        // }
    },

    // Get monthly purchases summary by item group
    async fetchMonthlyPurchasesItemGroup({ commit }, payload)
    {
        const response = await portalapi.moduleReports.getMontlyPurchasesByItemGroup(payload.month, payload.year, payload.accountGroup, payload.itemGroup);
        commit("setMonthlyItemGroup", response[0]);
        // TODO: Implement checking once the API is available (Post go live)
        // if (response && response.status == vm.config.globalProperties.$constants.HTTP_STATUS_CODES.OK) {
        //     await commit("setMonthlyPurchases", response.data);
        // }
    },

};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
